// HomeWeb.jsx
import React, { useState, useRef } from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform, TouchableWithoutFeedback, TextInput, KeyboardAvoidingView, Alert } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from '../../components/baseWeb';
import styles from '../../styles/formularios';
import axios from 'axios';
import MaskInput, { Masks } from 'react-native-mask-input'; // Para aplicar máscara no CPF
export default function DadosContratanteWeb({ route }) {
  const navigation = useNavigation();
  // envio unico 

  const [usuario_id, setUsuario_id] = useState(null);
  const { endereco_imovel, email_solicitante, valor_de_venda, percentual_corretagem } = route.params || {};

  console.log("Dados recebidos:", valor_de_venda, endereco_imovel, percentual_corretagem)
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [proprietarios, setProprietarios] = useState([
    {
      nomeCompleto: '',
      email_contratante: '',
      cpf_contratante: '',
      tel_contratante: '',
      cep_contratante: '',
      endereco_contratante: '',
      complemento_contratante: '',
      bairro_contratante: '',
      cidadeUf_contratante: '',
    },
  ]);

  const handleCepChange = (text, index) => {
    const formattedCep = text.replace(/\D/g, '').replace(/(\d{5})(\d{3})/, '$1-$2');
    atualizarProprietario(index, 'cep_contratante', formattedCep);
    if (formattedCep.length === 9) {
      atualizarEnderecoViaCep(formattedCep, index);
    }
  };

  const nomeCompletoRef = useRef([]);
  const cpfRef = useRef([]);
  const cepRef = useRef([]);

  const atualizarProprietario = (index, campo, valor) => {
    const novosProprietarios = [...proprietarios];
    novosProprietarios[index][campo] = valor;
    setProprietarios(novosProprietarios);
  };

  const adicionarProprietario = () => {
    setProprietarios([
      ...proprietarios,
      {
        nomeCompleto: '',
        email_contratante: '',
        cpf_contratante: '',
        tel_contratante: '',
        cep_contratante: '',
        endereco_contratante: '',
        complemento_contratante: '',
        bairro_contratante: '',
        cidadeUf_contratante: '',
      },
    ]);
  };

  const atualizarEnderecoViaCep = async (cep, index) => {
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep.replace('-', '')}/json/`);
      if (response.data) {
        const novosProprietarios = [...proprietarios];
        const p = { ...novosProprietarios[index] };

        // Atualiza com base no que foi retornado, mantendo campo editável
        p.endereco_contratante = response.data.logradouro || p.endereco_contratante;
        p.bairro_contratante = response.data.bairro || p.bairro_contratante;
        p.cidadeUf_contratante = `${response.data.localidade}/${response.data.uf}` || p.cidadeUf_contratante;

        novosProprietarios[index] = p;
        setProprietarios(novosProprietarios);
      }
    } catch (error) {
      Alert.alert('Erro', 'Não foi possível buscar o CEP');
    }
  };

  const isEmailValido = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const isFormValid = () => {
    return proprietarios.every((p) => p.nomeCompleto && p.cpf_contratante && p.cep_contratante && isEmailValido(p.email_contratante));
  };

  const handleSaveImovel = async () => {

    const contratantesFormatados = proprietarios.map((p) => {
      const [cidade, uf] = (p.cidadeUf_contratante || '').split('/');
      return {
        nome: p.nomeCompleto,
        email: p.email_contratante,
        endereco: `${p.endereco_contratante} ${p.complemento_contratante}`.trim(),
        cpf: p.cpf_contratante,
        telefone: p.tel_contratante,
        cidade: cidade?.trim() || '',
        cep: p.cep_contratante,
        uf: uf?.trim() || '',
      };
    });

    const payload = {
      endereco_imovel,
      valor_venda: valor_de_venda,
      porcentagem_corretagem: percentual_corretagem,
      contratantes: contratantesFormatados,
    };

    // console.log(JSON.stringify(payload, null, 2));

    navigation.navigate('EtapasCorretagemWeb', { status: 3,  payload_prop: payload, endereco_imovel });

  };

  return (
    <BaseWeb>
      {(userInfo) => {
        return (
          <ScrollView contentContainerStyle={styles.contentMinimal}>
            <View style={styles.formContainer}>
              <Text style={styles.title}>Dados do(s) contratante(s)</Text>

              {proprietarios.map((p, index) => (
                <View key={index} style={styles.proprietarioContainer}>
                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Nome Completo</Text>
                    <TextInput
                      ref={(ref) => (nomeCompletoRef.current[index] = ref)}
                      style={styles.areaInput}
                      placeholder="Nome Completo"
                      value={p.nomeCompleto}
                      onChangeText={(text) => atualizarProprietario(index, 'nomeCompleto', text)}
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>CPF</Text>
                    <MaskInput
                      ref={(ref) => (cpfRef.current[index] = ref)}
                      style={styles.areaInput}
                      value={p.cpf_contratante}
                      onChangeText={(text) => atualizarProprietario(index, 'cpf_contratante', text)}
                      mask={Masks.BRL_CPF}
                      placeholder="000.000.000-00"
                      placeholderTextColor="#A9A9A9"
                      keyboardType="numeric"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Telefone</Text>
                    <MaskInput
                      style={styles.areaInput}
                      value={p.tel_contratante}
                      onChangeText={(text) => atualizarProprietario(index, 'tel_contratante', text)}
                      mask={Masks.BRL_PHONE}
                      placeholder="(00) 00000-0000"
                      placeholderTextColor="#A9A9A9"
                      keyboardType="phone-pad"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>E-mail</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.email_contratante}
                      onChangeText={(text) => atualizarProprietario(index, 'email_contratante', text)}
                      placeholder="exemplo@email.com"
                      placeholderTextColor="#A9A9A9"
                      keyboardType="email-address"
                      autoCapitalize="none"
                      autoCorrect={false}
                    />
                    {p.email_contratante.length > 0 && !isEmailValido(p.email_contratante) && (
                      <Text
                        style={{
                          color: 'red',
                          marginTop: 5,
                          fontSize: 12,
                        }}
                      >
                        E-mail inválido
                      </Text>
                    )}
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>CEP</Text>
                    <TextInput
                      ref={(ref) => (cepRef.current[index] = ref)}
                      style={styles.areaInput}
                      value={p.cep_contratante}
                      onChangeText={(text) => handleCepChange(text, index)}
                      placeholder="00.000-000"
                      placeholderTextColor="#A9A9A9"
                      keyboardType="numeric"
                      maxLength={9}
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Endereço</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.endereco_contratante}
                      onChangeText={(text) => atualizarProprietario(index, 'endereco_contratante', text)}
                      placeholder="Rua, Avenida..."
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Complemento</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.complemento_contratante}
                      onChangeText={(text) => atualizarProprietario(index, 'complemento_contratante', text)}
                      placeholder="Apto, Bloco..."
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Bairro</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.bairro_contratante}
                      onChangeText={(text) => atualizarProprietario(index, 'bairro_contratante', text)}
                      placeholder="Bairro"
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Cidade/UF</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.cidadeUf_contratante}
                      onChangeText={(text) => atualizarProprietario(index, 'cidadeUf_contratante', text)}
                      placeholder="Cidade/UF"
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.divider} />
                </View>
              ))}
              {/* Inputs de Área */}

              <TouchableOpacity style={styles.laterButton} onPress={adicionarProprietario}>
                <Text style={styles.laterButtonText}>Adicionar contratante</Text>
              </TouchableOpacity>
              {/* Botão Salvar */}
              <View style={styles.buttonContainer}>
                <TouchableOpacity
                  style={[
                    styles.saveButton,
                    (!isFormValid() || isSubmitting) && { backgroundColor: '#ccc' },
                  ]}
                  onPress={handleSaveImovel}
                  disabled={!isFormValid() || isSubmitting} // Desabilita durante a submissão
                >
                  <Text style={styles.saveButtonText} allowFontScaling={false}>
                    {isSubmitting ? "Enviando..." : "Salvar"}
                  </Text>
                </TouchableOpacity>

                <TouchableOpacity style={styles.laterButton}>
                  <Image
                    source={require('../../../assets/icons/bookmark.png')} // Ícone de terminar mais tarde
                    style={styles.laterIcon}
                  />
                  <Text
                    style={styles.laterButtonText}
                    allowFontScaling={false}
                    onPress={() => navigation.navigate('Home', { usuario_id })}
                  >
                    Terminar mais tarde
                  </Text>
                </TouchableOpacity>
              </View>

            </View>
          </ScrollView>
        );
      }}
    </BaseWeb>
  );
}
